/* eslint-disable max-len */
import React, {
	useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState } from '../../../stores/types/types';

import {
	exportMeetingJSON,
	importMeetingJSON,
} from '../../../stores/actions/meeting';
import { APP } from '../../../stores/session-status';

export default function DebugExport() {
	const dispatch = useDispatch();

	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const meeting = useSelector((state: GreenroomState) => state.SessionReducer.meeting);
	const appSignedInWith = useSelector(
		(state: GreenroomState) => state.SessionReducer.appSignedInWith,
	);

	const [meetingJsonData, setMeetingJsonData] = useState<string | null>();

	const exportRoomToJson = () => {
		if (!meeting) {
			// eslint-disable-next-line no-alert
			alert('There is no meeting or current shot...');
			return;
		}

		if (!token) {
			// eslint-disable-next-line no-alert
			alert('There is no token...');
			return;
		}

		const {
			meeting: meetingId,
			title,
		} = meeting;

		dispatch(exportMeetingJSON(token, meetingId, title));
	};

	const validateMeetingJson = (event: any) => {
		const selectedFile = event.target.files[0];
		const reader = new FileReader();
		reader.onload = (readerEvent) => {
			if (readerEvent?.target?.result) {
				setMeetingJsonData(readerEvent.target.result.toString());
			}
		};
		reader.readAsText(selectedFile);
	};

	const importJson = (): void => {
		if (!token || !meeting) return;
		if (!meetingJsonData || meetingJsonData === '') {
			// eslint-disable-next-line no-alert
			alert('You must add json data');
			return;
		}

		try {
			// validate is json data
			JSON.parse(meetingJsonData);

			// create new meeting in current channel
			const { channel } = meeting;

			dispatch(importMeetingJSON(token, meetingJsonData, channel, (result: any) => {
				const code = result?.newMeeting?.meeting_id;
				window.location.href = `/producer/${code}`;
			}));
		} catch (e) {
			const message = e instanceof Error
				? e.message
				: 'Unknown error';
			// eslint-disable-next-line no-console
			console.error(e);
			// eslint-disable-next-line no-alert
			alert(`Invalid JSON => ${message}`);
		}
	};

	return (
		<>
			<div className="section reset" style={{ marginBottom: '16px' }}>
				<h5>Import Greenroom JSON</h5>
				<div style={{ maxWidth: '100%', marginBottom: '16px' }}>
					<div>Creates a brand new meeting using the same channel.</div>
					<div>Meetings can only be imported using Standalone.</div>
					<div>User must have a Brandlive Email Address to import.</div>
				</div>
				<input
					type="file"
					id="meeting-import-file"
					onChange={validateMeetingJson}
					style={{ marginBottom: '1rem' }}
					disabled={appSignedInWith !== APP.GREENROOM}
				/>
				<button
					className="padding-small background-green text-dark border-radius-small"
					onClick={importJson}
					title="Import Room JSON export elsewhere."
					disabled={appSignedInWith !== APP.GREENROOM}
				>
					Import Room
				</button>
			</div>
			<div className="section reset">
				<h5>Export Greenroom JSON</h5>
				<div style={{ maxWidth: '100%', marginBottom: '16px' }}>
					<div>Both Brandlive and Standalone meetings can be exported.</div>
				</div>
				<button
					className="padding-small background-green text-dark border-radius-small"
					onClick={exportRoomToJson}
					title="Export Room in JSON to be imported else where."
				>
					Export Room
				</button>
			</div>
			<div title="Not over me silly, the buttons">&nbsp;</div>
			<div title="Not over me silly, the buttons">&nbsp;</div>
			<div title="Not over me silly, the buttons">Current Dependency JSON</div>
			<div className="section reset">
				<iframe
					src={'/dev-info-package.html'}
					style={{
						backgroundColor: '#A6FF79',
						fontSize: '10pt',
						height: '420px',
						width: '505px',
					}}
				/>
			</div>
		</>
	);
}
